import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {SystemUsersState} from "@/store/user_management/system_users/types";

export const getters: GetterTree<SystemUsersState, RootState> = {
  systemUsers: state => state.systemUsers ?? [],
  systemPages: state => state.systemPages ?? [],
}
